import Vue from 'vue'
import { makeQueryStringDync, makeQueryFormDataDyn, errorServeiceHandler } from '../../helper'

const state = {
    selectedPackageDetails: [],
};

const getters = {
    getSelectedPackageDetails: (state) => {
        return state.selectedPackageDetails;
    }
};

const mutations = {
    setSelectedPackageDetails: (state, data) => {
        state.selectedPackageDetails = data;
    }
};

const actions = {
    actGetDisconnectedList: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }
            //Remove Multiple call code
            let getDisconnectSearch = JSON.parse(localStorage.getItem('getDisconnectSearch'))
            let lastCustomerSearch = JSON.parse(localStorage.getItem('lastDisonnectCustomerSearch'))
            if (getDisconnectSearch && lastCustomerSearch) {
                if (Object.keys(getDisconnectSearch).length && lastCustomerSearch == payload.subscriberid) {
                resolve(getDisconnectSearch)
                return
                }
            }
            //Remove Multiple call code End

            let queryStr = ''
            queryStr = makeQueryStringDync(payload);
            fetch(context.getters.baseUrl + '/lco/v1/disconnect.php' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json();
                }).then((data) => {
                    localStorage.setItem("getDisconnectSearch",JSON.stringify(data))
                    localStorage.setItem("lastDisonnectCustomerSearch",JSON.stringify(payload.subscriberid))
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    actGetReconnectList: (context, payload) => {
        return new Promise((resolve, reject) => {
            //Remove Multiple call code
            let getReconnectearch = JSON.parse(localStorage.getItem('getReconnectearch'))
            let lastCustomerSearch = JSON.parse(localStorage.getItem('lastReconnectCustomerSearch'))
            if (getReconnectearch && lastCustomerSearch) {
                if (Object.keys(getReconnectearch).length && lastCustomerSearch == payload.subscriberid) {
                resolve(getReconnectearch)
                return
                }
            }
            //Remove Multiple call code End
            if (!payload) {
                reject({ error: "payload not found" });
            }

            let queryStr = ''

            queryStr = makeQueryStringDync(payload);

            fetch(context.getters.baseUrl + '/lco/v1/reconnect.php' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    localStorage.setItem("getReconnectearch",JSON.stringify(data))
                    localStorage.setItem("lastReconnectCustomerSearch",JSON.stringify(payload.subscriberid))
                    resolve(data)
                }).catch((error) => {
                    
                    reject(error);
                });
        });
    },
    actGetCancelList: (context, payload) => {
        return new Promise((resolve, reject) => {

            //Remove Multiple call code
            let getCancelSearch = JSON.parse(localStorage.getItem('getCancelSearch'))
            let lastCustomerSearch = JSON.parse(localStorage.getItem('lastCancelCustomerSearch'))
            if (getCancelSearch && lastCustomerSearch) {
                if (Object.keys(getCancelSearch).length && lastCustomerSearch == payload.subscriberid) {
                resolve(getCancelSearch)
                return
                }
            }
            //Remove Multiple call code End

            if (!payload) {
                reject({ error: "payload not found" });
            }

            let queryStr = ''
            queryStr = makeQueryStringDync(payload);

            fetch(context.getters.baseUrl + '/lco/v1/plan/cancelproduct.php' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json();
                }).then((data) => {
                    localStorage.setItem("getCancelSearch",JSON.stringify(data))
                    localStorage.setItem("lastCancelCustomerSearch",JSON.stringify(payload.subscriberid))
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    disconnectPack: (context, formdata) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/disconnect.php', {
                method: 'POST',
                body: formdata
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json();
                }).then((data) => {
                   
                        resolve(data)
                    
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    reconnectPack: (context, formdata) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/reconnect.php', {
                method: 'POST',
                body: formdata
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json();
                }).then((data) => {
                    
                        resolve(data)
                

                }).catch((error) => {
                    reject(error);
                });
        });
    },
    cancelPack: (context, formdata) => {
        return new Promise((resolve, reject) => {
            fetch(context.getters.baseUrl + '/lco/v1/plan/cancel', {
                method: 'POST',
                body: formdata
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json();
                }).then((data) => {
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    getbasepack: (context, filterData) => {
        let newurl = filterData.url
        delete filterData.url
        return new Promise((resolve, reject) => {
            //Remove Multiple call code
            if (newurl == '/lco/v1/plan/subscriber') {
                let getChangeBaseSearch = JSON.parse(localStorage.getItem('getChangeBaseSearch'))
                let lastModifyCustomerSearch = JSON.parse(localStorage.getItem('lastChangebaseCustomerSearch'))
                if (getChangeBaseSearch && lastModifyCustomerSearch) {
                    if (Object.keys(getChangeBaseSearch).length && lastModifyCustomerSearch == filterData.subscriberid) {
                        resolve(getChangeBaseSearch)
                        return
                    }
                }
            }
            //Remove Multiple call code End
            let queryStr = ''
            queryStr = makeQueryStringDync(filterData)

            fetch(context.getters.baseUrl + newurl + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    if (newurl == '/lco/v1/plan/subscriber') {
                        localStorage.setItem("getChangeBaseSearch",JSON.stringify(data))
                        localStorage.setItem("lastChangebaseCustomerSearch",JSON.stringify(filterData.subscriberid))
                    }
                    resolve(data)
                }).catch((error) => {
                    reject(error);
                });
        });
    },
    getchangevaliditypackData: (context, filterData) => {
        let newurl = filterData.url
        delete filterData.url
        return new Promise((resolve, reject) => {
            //Remove Multiple call code
            let getChangeValiditySearch = JSON.parse(localStorage.getItem('getChangeValiditySearch'))
            let lastModifyCustomerSearch = JSON.parse(localStorage.getItem('lastChangeValidiyCustomerSearch'))
            if (getChangeValiditySearch && lastModifyCustomerSearch) {
                if (Object.keys(getChangeValiditySearch).length && lastModifyCustomerSearch == filterData.subscriberid) {
                resolve(getChangeValiditySearch)
                return
                }
            }
            //Remove Multiple call code End
            let queryStr = ''
            queryStr = makeQueryStringDync(filterData)

            fetch(context.getters.baseUrl + newurl + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    localStorage.setItem("getChangeValiditySearch",JSON.stringify(data))
                    localStorage.setItem("lastChangeValidiyCustomerSearch",JSON.stringify(filterData.subscriberid))
                    resolve(data)
                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve(
                            {"status":"A","name":"testtest test01","mobile":8987876767,"email":"","balance":-354,"subscriberid":27018460,"frcode":"FR5125","frcan":20893551,"region":"MUM","customertype":"NPR02","nonrenewable":false,"customertag":{"0":"SD STB Foundation FREE DN00368 2021SEP@Rs 800"},"hardwaretype":"MPEG2","basepack":"YES","planlist":[{"status":"ACTIVE","contractstatus":"A","planname":"Foundation + BANGLA Power","contractno":189775598,"plancode":"BST00032PP","tariffperiod":"3","validity":"2022-02-01","planid":"JoJP9HYL","plantype":"BASE","servicecode":"[\"BST00014CS\",\"BST00032CS\"]","packagecode":"[\"BST0033PKG\"]","description":"Foundation + BANGLA Power","lcoprice":"579.15","mrptariff":"1455.00","currency":"INR","region":"MUM","lcoregion":"MUM","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"discountedlcoprice":null,"ncfprice":"126.00","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"216"},{"status":"ACTIVE","contractstatus":"A","planname":"&FLIX","contractno":189775599,"plancode":"ALA0001PP","tariffperiod":"1","validity":"2021-12-01","planid":"JWtNA2Kf","plantype":"CHANNEL","servicecode":"[\"ALA0001CS\"]","packagecode":null,"description":"&flix","lcoprice":"13.50","mrptariff":"15.00","currency":"INR","region":"MUM","lcoregion":"MUM","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"discountedlcoprice":null,"ncfprice":"0.00","hardwaretype":"ALL","plancategory":"NCF","numchannels":"1"},{"status":"ACTIVE","contractstatus":"A","planname":"CHHOTA PACK","contractno":189775623,"plancode":"INB090935D","tariffperiod":"3","validity":"2021-11-12","planid":"91UTk6OR","plantype":"PACKAGE","servicecode":"[\"INB00118CS\"]","packagecode":"","description":"Test plan 3\/5Days","lcoprice":"3.00","mrptariff":"3.00","currency":"INR","region":"MUM","lcoregion":"MUM","planmode":"RENEWABLE","tariffperiodtype":"D","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"discountedlcoprice":null,"ncfprice":"0.00","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"5"},{"status":"ACTIVE","contractstatus":"A","planname":"OTT PLAN","contractno":189775571,"plancode":"OTTPLAN","tariffperiod":"30","validity":"2021-12-25","planid":"XX4u9SfH","plantype":"CHANNEL","servicecode":"","packagecode":"","description":"OTT PLAN","lcoprice":"300.00","mrptariff":"300.00","currency":"INR","region":"MUM","lcoregion":"MUM","planmode":"RENEWABLE","tariffperiodtype":"D","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"discountedlcoprice":null,"ncfprice":"0.00","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"5"},{"status":"ACTIVE","contractstatus":"A","planname":"GUJARATI PLUS","contractno":189775624,"plancode":"INB0005PP","tariffperiod":"3","validity":"2022-02-09","planid":"5Re42KuC","plantype":"PACKAGE","servicecode":"[\"INB0005CS\"]","packagecode":"","description":"GUJARATI PLUS","lcoprice":"350.34","mrptariff":"130.25","currency":"INR","region":"MUM","lcoregion":"MUM","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"discountedlcoprice":null,"ncfprice":"27.00","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"77"}],"channelcount":1,"validityplans":[{"planid":"Q0ug2Lt9","planname":"Foundation + BANGLA Power","plantype":"BASE","plancode":"BST00032PP","servicecode":"[\"BST00014CS\",\"BST00032CS\"]","packagecode":"[\"BST0033PKG\"]","description":"Foundation + BANGLA Power","lcoprice":"2316.60","mrptariff":"5820.00","tariffperiod":"12","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"504.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"216","schedulestatus":"NO","renewtill":null},{"planid":"qGrSCtdn","planname":"Foundation + BANGLA Power","plantype":"BASE","plancode":"BST00032PP","servicecode":"[\"BST00014CS\",\"BST00032CS\"]","packagecode":"[\"BST0033PKG\"]","description":"Foundation + BANGLA Power","lcoprice":"1158.32","mrptariff":"2910.00","tariffperiod":"6","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"252.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"216","schedulestatus":"NO","renewtill":null},{"planid":"rYn2NjRE","planname":"FOUNDATION + BANGLA POWER","plantype":"BASE","plancode":"BST00032PP","servicecode":"[\"BST00014CS\",\"BST00032CS\"]","packagecode":"[\"BST0033PKG\"]","description":"BST BANGLA Power","lcoprice":"193.05","mrptariff":"485.00","tariffperiod":"1","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"42.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"216","schedulestatus":"NO","renewtill":null},{"planid":"AeMbiAHk","planname":"CHHOTA PACK","plantype":"PACKAGE","plancode":"INB090935D","servicecode":"[\"INB00118CS\"]","packagecode":"","description":"Test plan 3\/5Days","lcoprice":"5.00","mrptariff":"5.00","tariffperiod":"5","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"D","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"5","schedulestatus":"NO","renewtill":null},{"planid":"DpRlX3GL","planname":"OTT PLAN","plantype":"CHANNEL","plancode":"OTTPLAN","servicecode":"","packagecode":"","description":"OTT PLAN","lcoprice":"1800.00","mrptariff":"1800.00","tariffperiod":"180","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"D","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"5","schedulestatus":"NO","renewtill":null},{"planid":"VvfdRUMU","planname":"OTT PLAN","plantype":"CHANNEL","plancode":"OTTPLAN","servicecode":"","packagecode":"","description":"OTT PLAN","lcoprice":"900.00","mrptariff":"900.00","tariffperiod":"90","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"D","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"0.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"5","schedulestatus":"NO","renewtill":null},{"planid":"3CmJPWYi","planname":"GUJARATI PLUS","plantype":"PACKAGE","plancode":"INB0005PP","servicecode":"[\"INB0005CS\"]","packagecode":"","description":"GUJARATI PLUS","lcoprice":"1401.36","mrptariff":"130.25","tariffperiod":"12","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"108.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"77","schedulestatus":"NO","renewtill":null},{"planid":"3ldoD8GJ","planname":"GUJARATI PLUS","plantype":"PACKAGE","plancode":"INB0005PP","servicecode":"[\"INB0005CS\"]","packagecode":"","description":"GUJARATI PLUS","lcoprice":"700.68","mrptariff":"130.25","tariffperiod":"6","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"54.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"77","schedulestatus":"NO","renewtill":null},{"planid":"9g8TJcca","planname":"GUJARATI PLUS","plantype":"PACKAGE","plancode":"INB0005PP","servicecode":"[\"INB0005CS\"]","packagecode":null,"description":"GUJARATI PLUS","lcoprice":"116.78","mrptariff":"130.25","tariffperiod":"1","currency":"INR","region":"MUM","lcoregion":"MUM","status":"ACTIVE","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"ncfprice":"9.00","discountedlcoprice":null,"renewperiod":"12","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"77","schedulestatus":"YES","renewtill":null}]})
                        return
                    }
                    reject(error);
                });
        });
    },
    actGetDisconnectForRefundList: (context, payload) => {
        return new Promise((resolve, reject) => {
            if (!payload) {
                reject({ error: "payload not found" });
            }

            //Remove Multiple call code
            let getDisconnectRefundSearch = JSON.parse(localStorage.getItem('getDisconnectRefundSearch'))
            let lastModifyCustomerSearch = JSON.parse(localStorage.getItem('lastRefundCustomerSearch'))
            if (getDisconnectRefundSearch && lastModifyCustomerSearch) {
                if (Object.keys(getDisconnectRefundSearch).length && lastModifyCustomerSearch == payload.subscriberid) {
                resolve(getDisconnectRefundSearch)
                return
                }
            }
            //Remove Multiple call code End

            let queryStr = ''
            queryStr = makeQueryStringDync(payload);
            fetch(context.getters.baseUrl + '/lco/v1/disconnect.php' + queryStr, {
                method: 'GET'
            })
                .then(errorServeiceHandler)
                .then((response) => {
                    return response.json()
                }).then((data) => {
                    localStorage.setItem("getDisconnectRefundSearch",JSON.stringify(data))
                    localStorage.setItem("lastRefundCustomerSearch",JSON.stringify(payload.subscriberid))
                    resolve(data)
                }).catch((error) => {
                    if (context.getters.getMode == "development") {
                        resolve({"0":{"status":"ACTIVE","contractstatus":"A","planname":"ALANKAR","contractno":141350963,"plancode":"ALA0017PP","tariffperiod":"1","validity":"2020-06-05","planid":"FqTU6LZ9","plantype":"CHANNEL","servicecode":"[\"ALA0017CS\"]","packagecode":null,"description":"ALANKAR","lcoprice":"3.60","mrptariff":"4.00","currency":"INR","region":"MUM","lcoregion":"MUM","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"discountedlcoprice":null,"ncfprice":"0.00","hardwaretype":"ALL","plancategory":"NCF","numchannels":"1"},"1":{"status":"ACTIVE","contractstatus":"A","planname":"&FLIX","contractno":141198026,"plancode":"ALA0001PP","tariffperiod":"1","validity":"2020-06-04","planid":"JWtNA2Kf","plantype":"CHANNEL","servicecode":"[\"ALA0001CS\"]","packagecode":null,"description":"&flix","lcoprice":"13.50","mrptariff":"15.00","currency":"INR","region":"MUM","lcoregion":"MUM","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"discountedlcoprice":null,"ncfprice":"0.00","hardwaretype":"ALL","plancategory":"NCF","numchannels":"1"},"2":{"status":"ACTIVE","contractstatus":"A","planname":"Foundation + IN HINDI SUPER ENTERTAINMENT PACK","contractno":141109084,"plancode":"BST00013PP","tariffperiod":"1","validity":"2020-06-03","planid":"YW8Rel2U","plantype":"BASE","servicecode":"[\"BST00014CS\",\"INB00082CS\"]","packagecode":"[\"BST0056PKG\"]","description":"Foundation + IN HINDI SUPER ENTERTAINMENT PACK","lcoprice":"151.43","mrptariff":"168.25","currency":"INR","region":"MUM","lcoregion":"MUM","planmode":"RENEWABLE","tariffperiodtype":"M","effectivedate":null,"newlcoprice":null,"newmrptariff":null,"discountedlcoprice":null,"ncfprice":"39.00","hardwaretype":"ALL","plancategory":"NORMAL","numchannels":"201"},"name":"Shree Sai Cable Video Network Swo"})
                    }
                    reject(error);
                });
        });
    },
    deactivateValidityPlan: (context, payload) => {
        return new Promise((resolve, reject) => {
           let data = makeQueryFormDataDyn(payload);
           fetch(context.getters.baseUrl + '/lco/v1/plan/deactiavteplan', {
            method: 'POST',
            body: data
           })
           .then(errorServeiceHandler)
           .then((response) => {
              return response.json()    
           }).then((data) => {
                resolve(data)
            }).catch((error) => {
                if (context.getters.getMode == "development") {
                    resolve({"success":"1"})
                    return
                }
                reject(error)
            });
        });
      },
};

export default {
    state, getters, mutations, actions
};


// WEBPACK FOOTER //
// ./src/store/modules/productModule/modifyModule.js